import styled from "@emotion/styled"
import { IconProp } from "@fortawesome/fontawesome-svg-core"
import { faChevronRight, faFolder, } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Grid, Stack, Typography } from "@mui/material"

import theme from "css/theme/light"
import { allRoutes } from "generated/routes"
import { IDocumentFolder } from "pages/documents/interface/folder.interface"
import { useTranslation } from "react-i18next"
import { NavLink } from "react-router-dom"

export const StyledBoxWrapper = styled(Grid)({
  borderRadius: "16px",
  padding: "48px 32px",
  [theme.breakpoints.down("lg")]: {
    padding: "24px 16px"
  },
  background: theme.palette.background.paper,
})

export const StyledNavLink = styled(NavLink)({
  background: theme.palette.background.paper,
})

const Folder = ({ foldersResult }: { foldersResult: any }) => {
  const { t } = useTranslation("translation", { keyPrefix: "documents" })

  return (
    <StyledBoxWrapper gap={2} display="flex" flexDirection="column">
      {
        foldersResult.data?.map((folder: IDocumentFolder, index: number) => (
          <StyledNavLink
            style={{ color: "inherit", textDecoration: "inherit" }}
            to={allRoutes.DocumentsDetails(folder.id)}
            isActive={(match, location): any => {
              if (!match) {
                return false
              }
              return true
            }}>
            <Grid container direction="row" justifyContent="space-between">
              <Grid item>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <FontAwesomeIcon
                    size="sm"
                    color={theme.palette.warning[500]}
                    icon={faFolder as IconProp}
                  />
                  <Typography variant="bodyMedium">
                    {folder.name}
                  </Typography>
                </Stack>
              </Grid>

              <Grid item display="flex" alignItems="center" gap={4}>
                <Typography color={theme.palette.grey["500"]} variant="bodySmall">
                  {folder.totalAttachments}{" "}
                  {folder.totalAttachments === 1 ? t(`list.file`) : t(`list.files`)}
                </Typography>
                <FontAwesomeIcon
                  size="sm"
                  color={theme.palette.grey["500"]}
                  icon={faChevronRight as IconProp}
                />
              </Grid>
            </Grid>
          </StyledNavLink>
        ))}
    </StyledBoxWrapper>
  )
}
export default Folder
